import React, { useRef, useState } from 'react'

import classNames from 'classnames'
import { isMobile } from 'react-device-detect'

import useOutsideClick from '@web/hooks/useOutsideClick'
import { ClickHandler } from '@web/types'

import Button from './Button'
import styles from './ContextMenu.module.scss'
import MenuItem, { MenuItemProps } from './MenuItem'

export interface ButtonType {
  toggled: boolean
  clickHandler: ClickHandler
}

interface Props {
  buttonComponent?: React.FC<ButtonType>
  button?: {
    alt: string
    clickCode?: string
    disabled?: boolean
    iconStyleClass?: string
    styleClass?: string
    type?: string
  }
  layerStyleClass?: string
  hide?: () => void
  items: MenuItemProps[]
  onClick?: ClickHandler
}

const ContextMenu = ({
  button,
  buttonComponent: ButtonComponent,
  items,
  layerStyleClass = '',
  hide,
  onClick,
}: Props) => {
  const menuRef = useRef<HTMLDivElement>(null)
  const [showMenu, setShowMenu] = useState<boolean>(false)

  const onClickButton: ClickHandler = e => {
    setShowMenu(!showMenu)
    onClick?.(e)
  }
  const closeMenu = () => setShowMenu(false)

  useOutsideClick({ innerRef: menuRef, callback: closeMenu, useHooks: showMenu })

  return (
    <div className={classNames(styles.context_menu_wrapper)} ref={menuRef}>
      {!!ButtonComponent && <ButtonComponent toggled={showMenu} clickHandler={onClickButton} />}
      {!!button && (
        <Button
          clickHandler={onClickButton}
          alt={button.alt}
          buttonClass={button.styleClass}
          clickCode={button.clickCode}
          iconStyleClass={button.iconStyleClass}
          disabled={button.disabled}
          isPopupOpen={showMenu}
        />
      )}
      {showMenu && (
        <div className={classNames(styles.ly_manage, layerStyleClass)}>
          {items.map((item, idx) =>
            item?.visibility ? (
              <MenuItem
                clickCode={item.clickCode}
                clickHandler={e => {
                  item.clickHandler?.(e)
                  if (isMobile) closeMenu()
                }}
                hide={hide}
                icon={item.icon}
                key={idx}
                label={item.label}
                subLabel={item.subLabel}
              />
            ) : null,
          )}
        </div>
      )}
    </div>
  )
}

export default ContextMenu
